<template>
  <div class="device-qrcode">
    <vue-qr :text="url" :logoSrc="require('../assets/logo-qrcode.png')" :margin="0" :size="size"></vue-qr>

    <span v-if="!hideBottom" class="serialNumber-span">{{serialNumber}}</span>
  </div>
</template>

<script>
import VueQr from 'vue-qr'

export default {
  name: 'device-qrcode',

  components: { VueQr },

  props: {
    serialNumber: [String, Number],
    hideBottom: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 200
    }
  },

  computed: {
    url() {
      // let redirect_uri = encodeURI(
      //   `${this.$web_url}anonymity-query-mobile/${this.serialNumber}`
      // )
      // return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.$app_id}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base#wechat_redirect`

      return `${this.$web_url}a/${btoa(this.serialNumber)}`
    }
  },

  created() {
    console.log(this.url)
  }
}
</script>

<style scoped lang="less">
.serialNumber-span {
  display: block;
  text-align: center;
  width: 200px;
  padding-top: 16px;
  font-size: 16px;
  color: black;
}
</style>
